"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const ChangeOwner = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M18 5a3 3 0 11-6 0 3 3 0 016 0zm-3 5.107c1.303 0 2.51-.41 3.494-1.107C19.906 9.17 21 10.358 21 11.798v5.92a.284.284 0 01-.286.282h-6.733A6.504 6.504 0 009 12.174v-.376c0-1.44 1.094-2.627 2.507-2.798A6.027 6.027 0 0015 10.107zM2.206 14.841a.2.2 0 000 .316l3.972 3.058a.2.2 0 00.322-.158V16h1a2.5 2.5 0 11-1.915 4.108c-.355-.423-.904-.74-1.432-.578-.528.162-.833.73-.558 1.209A4.5 4.5 0 107.499 14H6.5v-2.058a.2.2 0 00-.322-.158l-3.972 3.058z",
        clipRule: "evenodd"
      }
    )
  );
};
export default ChangeOwner;
